import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const qmsDocumentTypeActions = {
  add: (newDocumentTypeData) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTTYPES.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocumentType";
    try {
      const res = await axios.post(apiEndpoint, newDocumentTypeData);
      dispatch({
        type: QMS.DOCUMENTTYPES.ADD_FULFILLED,
        divisionId: newDocumentTypeData.divisionId,
        qmsDocumentTypes: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTTYPES.ADD_REJECTED });
      logError(e);
    }
  },
  update: (qmsDocumentTypeData) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTTYPES.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocumentType";
    try {
      const res = await axios.put(apiEndpoint, qmsDocumentTypeData);
      dispatch({
        type: QMS.DOCUMENTTYPES.UPDATE_FULFILLED,
        divisionId: qmsDocumentTypeData.divisionId,
        qmsDocumentTypes: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTTYPES.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (qmsDocumentTypeId, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTTYPES.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocumentType/" + qmsDocumentTypeId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.DOCUMENTTYPES.REMOVE_FULFILLED,
        qmsDocumentTypes: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTTYPES.REMOVE_REJECTED });
      logError(e);
    }
  },
  removeRange: (qmsDocumentTypeIds, divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTTYPES.REMOVE });
    const apiEndpoint_delete = `${BASE_URL}/api/qms/QmsDocumentType`;
    try {
      const delRes = await axios.delete(apiEndpoint_delete, {
        params: { ids: qmsDocumentTypeIds || [] },
        paramsSerializer: (params) => qs.stringify(params),
      });
      if (delRes.data.message) {
        dispatch({ type: QMS.DOCUMENTTYPES.REMOVE_REJECTED });
        // Show alert
        alert(delRes.data.message);
      } else {
        const apiEndpoint_getAll =
          BASE_URL + "/api/qms/QmsDocumentType/List/" + divisionId;
        const res = await axios.get(apiEndpoint_getAll);
        dispatch({
          type: QMS.DOCUMENTTYPES.REMOVE_FULFILLED,
          divisionId,
          qmsDocumentTypes: res.data,
        });
      }
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTTYPES.REMOVE_REJECTED });
      logError(e);
    }
  },
  getAll: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DOCUMENTTYPES.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/QmsDocumentType/List/" + divisionId;
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({
        type: QMS.DOCUMENTTYPES.FETCH_ALL_FULFILLED,
        qmsDocumentTypes: res.data,
        divisionId,
      });
    } catch (e) {
      dispatch({ type: QMS.DOCUMENTTYPES.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default qmsDocumentTypeActions;
